import React from "react";
import { IonIcon, IonButton, IonCard, IonList, IonToolbar, IonTitle, IonButtons } from "@ionic/react";
import { cameraOutline } from "ionicons/icons";
import CustomBox from "./CustomBox";
import { Camera, CameraResultType, CameraSource, CameraDirection } from "@capacitor/camera";
import SitePhotosList from "./SitePhotosList";
import { SitePhoto } from "../models/SitePhoto";
import { User } from "../models/User";

interface Props {
    sitePhotos?: SitePhoto[];
    onSitePhotoCaptured: (dataUrl: string) => void;
    onSitePhotoDeleted: (sitePhotoId: string) => void;
    isReadOnly: boolean;
    permitId: string;
    ableToAddPhotos: boolean;
    permitRegisterUsers?: User[];
}

const SitePhotos: React.FC<Props> = ({
    sitePhotos,
    permitId,
    onSitePhotoCaptured,
    onSitePhotoDeleted,
    isReadOnly,
    ableToAddPhotos,
    permitRegisterUsers,
}) => {
    const takePicture = async () => {
        try {
            const image = await Camera.getPhoto({
                resultType: CameraResultType.DataUrl,
                source: CameraSource.Camera,
                direction: CameraDirection.Rear,
                quality: 80,
            });

            if (image.dataUrl) {
                onSitePhotoCaptured(image.dataUrl);
            }
        } catch (error) {
            console.error("Error picking photo:", error);
        }
    };

    return (
        <>
            {ableToAddPhotos && !(sitePhotos && sitePhotos.length > 9) && (
                <IonCard>
                    <IonList lines="full">
                        <IonToolbar mode="md">
                            <IonTitle
                                slot="start"
                                style={{ padding: "16px" }}
                                class="ion-text-uppercase ion-hide-sm-down"
                                size="small"
                            >
                                Add site photo
                            </IonTitle>

                            <IonButtons slot="end">
                                <IonButton
                                    onClick={() => takePicture()}
                                    color="medium"
                                    size="small"
                                    style={{ marginLeft: "6px" }}
                                >
                                    <IonIcon slot="start" icon={cameraOutline} />
                                    Take Photo
                                </IonButton>
                            </IonButtons>
                        </IonToolbar>
                    </IonList>
                </IonCard>
            )}

            <CustomBox>
                <SitePhotosList
                    permitId={permitId}
                    sitePhotos={sitePhotos}
                    onSitePhotoDeleted={onSitePhotoDeleted}
                    isReadOnly={isReadOnly}
                    permitRegisterUsers={permitRegisterUsers}
                />
            </CustomBox>
        </>
    );
};

export default SitePhotos;
